var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5678 8.43469L26.5669 8.43688L24.4406 11.7298C25.0911 13.0131 25.46 14.4632 25.46 16.0002C25.46 21.2252 21.2243 25.4609 15.9993 25.4609C14.4643 25.4609 13.0159 25.093 11.7339 24.4441L8.43994 26.573C10.5704 28.099 13.1789 29.0001 15.9993 29.0001C23.179 29.0001 28.9993 23.1799 28.9993 16.0003C28.9993 13.1771 28.0964 10.5663 26.5678 8.43469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 22.5099C19.1998 22.5099 21.8605 20.2066 22.4191 17.1677C21.4062 16.9511 20.3561 16.8345 19.2785 16.8345C16.0339 16.8345 13.0332 17.8715 10.5828 19.6276C11.7559 21.3663 13.744 22.5099 15.9993 22.5099Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2181 15.6474C20.3545 15.6474 21.4616 15.7717 22.5292 16.0021C22.5292 16.0014 22.5292 16.0007 22.5292 15.9999C22.5292 12.3937 19.6059 9.47045 15.9998 9.47045C12.3938 9.47045 9.4704 12.3938 9.4704 15.9999C9.4704 16.2962 9.49247 16.587 9.53086 16.8727C9.5302 16.8732 9.52965 16.8735 9.52893 16.8741C7.88467 18.1228 7.10496 19.1124 7.0802 19.144C6.73217 18.1602 6.53919 17.1032 6.53919 15.9999C6.53919 10.7749 10.7748 6.53923 15.9998 6.53923C17.5298 6.53923 18.9737 6.90469 20.2526 7.54958L23.5486 5.41951C21.42 3.89816 18.8156 3 15.9999 3C8.82023 3 3 8.82023 3 15.9999C3 18.8896 3.94437 21.5577 5.53972 23.7156C6.15597 22.603 6.90402 21.5743 7.76271 20.6491C7.76271 20.6491 9.04494 19.3111 10.0274 18.6384C12.6072 16.759 15.782 15.6474 19.2181 15.6474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEonWhite);
export default __webpack_public_path__ + "static/media/eon-white.249d3146627cb10e803ac7d4fb516c7e.svg";
export { ForwardRef as ReactComponent };